import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import {
  Alert as BSAlert,
  Button,
  Label,
  OverlayTrigger,
  Panel,
  Tab,
  Tabs,
  Tooltip
} from "react-bootstrap";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import Loadable from "react-loading-overlay";
import Moment from "react-moment";
import { Link, useParams } from "react-router-dom";
import Alert from "react-s-alert";
import DealStatuses from "../Actions/dealStatuses";
import Auth from "../auth-context";
import EditContactModal from "../Contacts/EditContactModal";
import SeminarRegistrationPanel from "../SeminarRegistrations/SeminarRegistrationPanel";
import ConfirmButton from "../Shared/ConfirmButton";
import Field from "../Shared/Field";
import HistoryPanel from "../Shared/HistoryPanel";
import TaskPanel from "../Shared/TaskPanel";
import AssignTCSModal from "../TCS/AssignTCSModal";
import TCSPanel from "../TCS/TCSPanel";
import AiSalesReportService from "../utils/AiSalesReportService";
import DealsService from "../utils/DealsService";
import SeminarsService from "../utils/SeminarsService";
import { examBoardForRegion } from "../utils/variables";
import { e164 } from "../Voice/e164";
import AddContactModal from "./AddContactModal";
import DealButtonBar from "./ButtonBar";
import SeminarRegistrationButtonBar from "./ButtonBarRegistration";
import TCSButtonBar from "./ButtonBarTCS";
import CapacityAndCoachesPanel from "./CapacityAndCoachesPanel";
import Flags from "./Flags";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { inject, observer } from "mobx-react";

const Show = inject("dialerStore")(observer(({ dialerStore }) => {
  const authStore = useContext(Auth);

  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [deal, setDeal] = useState();
  const [capacityStats, setCapacityStats] = useState();
  const [openSeminars, setOpenSeminars] = useState();
  const [showModalAssignTCS, setShowModalAssignTCS] = useState();
  const [editContact, setEditContact] = useState();
  const [showModalEditContact, setShowModalEditContact] = useState();
  const [showModalAddContact, setShowModalAddContact] = useState();
  const [modalAssignDeal, setModalAssignDeal] = useState();
  const [analysisButtonText, setAnalysisButtonText] = useState("");
  const [showAnalysisButton, setShowAnalysisButton] = useState(true);

  useEffect(() => {
    loadDeal(id);
  }, [id]);

  useEffect(() => {
    if (id) {
      document.title = `${id}`;
    }
  }, [id]);

  const loadDeal = async id => {
    setIsLoading(true);
    const response = await DealsService.get(id);
    const deal = response.deal;
    setCapacityStats(response.stats);
    setDeal(deal);
    setIsLoading(false);
    loadOpenSeminars(deal);
    setAnalysisButtonText(
      deal.ai_sales_report ? "Re-Generate Analysis" : "Generate Analysis"
    );
  };

  const loadOpenSeminars = async deal => {
    if (!deal.registration_seminar_id) return;
    const openSeminars = await SeminarsService.openSeminars();
    const filtered = openSeminars
      .filter(
        seminar =>
          parseInt(seminar.id) !== parseInt(deal.registration_seminar_id)
      )
      .filter(
        seminar =>
          seminar.region === deal.lm_contact.region ||
          seminar.region === "ZOOM_WEBINAR"
      );
    setOpenSeminars(filtered);
  };

  const handleDealUpdated = deal => {
    setDeal(deal);
    loadOpenSeminars(deal);
  };

  const reloadDeal = () => {
    loadDeal(id);
  };

  const contactUpdated = contact => {
    setShowModalEditContact(false);
    setEditContact(undefined);
    reloadDeal();
  };

  const removeContact = contact => {
    DealsService.removeContact(id, contact.id).then(data => {
      Alert.success("Removed");
      reloadDeal();
    });
  };

  const TCSAssigned = () => {
    setShowModalAssignTCS(false);
    setModalAssignDeal(undefined);
    reloadDeal();
  };

  const assignTCS = () => {
    setShowModalAssignTCS(true);
    setModalAssignDeal(deal);
  };

  const handleAiAnalysisGeneration = () => {
    const hasTranscriptFile = deal.zoom_records.some(
      record => record.file_type === "VTT"
    );

    if (hasTranscriptFile) {
      setShowAnalysisButton(false);
      AiSalesReportService.create(id).then(data => {
        Alert.success(
          "Generating Reports in background! You'll receive an email shortly."
        );
      });
      reloadDeal();
    } else {
      Alert.error(
        "Can't generate reports because the transcription is unavailable."
      );
    }
  };

  const handleMakeTCSCall = () => {
    const phoneNumber = deal.lm_contact.mobile;
    if (!phoneNumber) {
      Alert.error("No mobile number available for this contact");
      return;
    }

    const parsedNumber = parsePhoneNumberFromString(phoneNumber, "AU");
    if (!parsedNumber || !parsedNumber.isValid()) {
      Alert.error("Invalid phone number");
      return;
    }

    // Set confirmation call flag to true
    dialerStore.confirmationCall = true;

    // Add number to dialer and show dialer
    dialerStore.addNumberToCall(parsedNumber.formatNational());
  };

  if (!deal) return null;

  const isRestrictedCoach = authStore.hasRole("coach_restricted");
  if (isRestrictedCoach && deal.tcs_assigned_to !== authStore.profile.email)
    return <div>You do not have permission to see this deal</div>;

  const contactUrl = deal.lm_contact
    ? `${process.env.REACT_APP_LEADMACHINE_URL}/app#!/contacts/${deal.lm_contact.lm_contact_id}`
    : "";

  const internationalNumber = e164(deal.lm_contact.mobile);
  const mcUrl = `${process.env.REACT_APP_LEADMACHINE_URL}/app#!/message_centre/messages/thread/${internationalNumber}`;

  const dealStatuses = new DealStatuses(deal, authStore);
  const statuses = dealStatuses.dealStatuses.statuses;

  return (
    <div>
      <Loadable
        active={isLoading}
        spinner
        text=""
        color="#444"
        background="rgba(255, 255, 255, 0.5)"
      >
        {deal && (
          <div>
            <h3 className="first-title">
              <i
                className="pull-right fas fa-sync refresh-deal subtle-hover-link"
                onClick={() => loadDeal(id)}
              ></i>
              Deal #{deal.id} : {deal.lm_contact.email} -{" "}
              {deal.lm_contact.region} /{" "}
              {examBoardForRegion(deal.lm_contact.region)}
            </h3>

            {deal.flags.includes("on_hold") ? (
              <div style={{ marginTop: 6 }}>
                <BSAlert variant="success">
                  <Button
                    className="pull-right"
                    bsStyle="warning"
                    bsSize="small"
                    onClick={() =>
                      DealsService.takeAction(
                        "take_off_hold",
                        deal.id,
                        {}
                      ).then(data => {
                        Alert.success("Taken Off Hold");
                        handleDealUpdated(data.deal);
                      })
                    }
                  >
                    Take Off Hold
                  </Button>
                  <p>
                    This Deal was put on hold by {deal.on_hold_by} until{" "}
                    {moment(deal.on_hold_until).format("DD MMM YYYY h:mm a")}
                  </p>
                  <p>
                    {deal.on_hold_reason.split("\n").map((item, key) => {
                      return (
                        <span key={key}>
                          {item}
                          <br />
                        </span>
                      );
                    })}
                  </p>
                </BSAlert>
              </div>
            ) : (
              <div>
                <div className="button-bar">
                  <h5>Seminar Registration Actions</h5>
                  <SeminarRegistrationButtonBar
                    deal={deal}
                    seminarsToRescheduleTo={openSeminars}
                    handleDealUpdated={handleDealUpdated}
                  />
                </div>
                <div className="button-bar">
                  <h5>Trial Coaching Session Actions</h5>
                  <TCSButtonBar
                    deal={deal}
                    handleDealUpdated={handleDealUpdated}
                    reloadDeal={reloadDeal}
                  />
                </div>
                <div className="button-bar">
                  <h5>
                    Deal Actions
                    <span style={{ marginLeft: 20 }}>
                      {!statuses.registrationCompleted && (
                        <Label
                          style={{
                            verticalAlign: "top",
                            borderRadius: 10,
                            marginLeft: 10,
                            background: "#ffe1b2",
                            color: "#333"
                          }}
                          bsStyle="warning"
                          bsSize="xsmall"
                        >
                          Registration Open
                        </Label>
                      )}
                      {!statuses.tcsCompleted && (
                        <Label
                          style={{
                            verticalAlign: "top",
                            borderRadius: 10,
                            marginLeft: 10,
                            background: "#ffe1b2",
                            color: "#333"
                          }}
                          bsStyle="warning"
                          bsSize="xsmall"
                        >
                          TCS Open
                        </Label>
                      )}
                    </span>
                  </h5>
                  <DealButtonBar
                    style={{ marginBottom: 6 }}
                    deal={deal}
                    handleDealUpdated={handleDealUpdated}
                  />
                </div>
              </div>
            )}

            <div className="row" style={{ clear: "both" }}>
              <div className="col-md-6">
                <Panel bsStyle="success" className="compact-panel">
                  <Panel.Heading>
                    <Panel.Title componentClass="h3">
                      <div>Deal</div>
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body>
                    <Flags deal={deal} />

                    <Tabs id="deal_tabs" className="compact-tabs">
                      <Tab eventKey={1} title="Deal Overview">
                        <Button
                          style={{ marginBottom: 2, marginRight: 10 }}
                          bsStyle="info"
                          bsSize="xsmall"
                          onClick={() => {
                            setShowModalEditContact(true);
                            setEditContact({ deal_id: deal.id });
                          }}
                        >
                          Create New Contact
                        </Button>
                        <Button
                          style={{ marginBottom: 2, marginRight: 10 }}
                          bsStyle="info"
                          bsSize="xsmall"
                          onClick={() => setShowModalAddContact(true)}
                        >
                          Add Existing Contact
                        </Button>

                        <div
                          className="well"
                          style={{
                            border: "1px solid #ddd",
                            background: "rgba(251, 251, 251, 0.51)",
                            padding: 6,
                            marginTop: 15
                          }}
                        >
                          <h4
                            style={{
                              marginTop: 0,
                              marginBottom: 4,
                              paddingBottom: 4
                            }}
                          >
                            {deal.lm_contact.contact_type} -{" "}
                            {deal.lm_contact.region} /{" "}
                            {examBoardForRegion(deal.lm_contact.region)}
                            <span className="pull-right">
                              <Button
                                style={{ marginRight: 6 }}
                                bsStyle="info"
                                bsSize="xsmall"
                                onClick={() => {
                                  setShowModalEditContact(true);
                                  setEditContact(deal.lm_contact);
                                }}
                              >
                                Edit
                              </Button>
                            </span>
                          </h4>
                          <div className="row">
                            <div className="col-md-8">
                              <Field
                                label="Region"
                                required={true}
                                value={deal.lm_contact.region}
                              />
                              <Field
                                label="Email"
                                required={true}
                                value={
                                  <Link
                                    to={`/m1/contacts/${deal.lm_contact.id}`}
                                  >
                                    {deal.lm_contact.email || "view contact"}
                                  </Link>
                                }
                              />
                              <Field
                                label="First Name"
                                value={deal.lm_contact.first_name}
                                required={true}
                              />
                              <Field
                                label="Last Name"
                                value={deal.lm_contact.last_name}
                                required={true}
                              />
                              <Field label="Mobile" required={true}>
                                {deal.lm_contact.mobile ? (
                                  <span>
                                    <button
                                      className="button-link"
                                      onClick={handleMakeTCSCall}
                                      style={{ marginRight: 8 }}
                                    >
                                      {deal.lm_contact.mobile}
                                    </button>
                                    {!deal.flags.includes('tcs_attendee_confirmed') && (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id="tcs-call-tooltip">
                                            This will generate AI reports for confirmation calls. Use this button for TCS confirmation calls only.
                                          </Tooltip>
                                        }
                                      >
                                        <Button
                                          bsStyle="success"
                                          bsSize="xsmall"
                                          onClick={handleMakeTCSCall}
                                        >
                                          Make TCS Call
                                        </Button>
                                      </OverlayTrigger>
                                    )}
                                  </span>
                                ) : (
                                  <strong>(required)</strong>
                                )}
                              </Field>
                              {(deal.lm_contact.bad_number ||
                                deal.lm_contact.unsubscribed_number) && (
                                <Field label="">
                                  {deal.lm_contact.bad_number && (
                                    <span
                                      style={{ marginRight: 4 }}
                                      className="label label-danger"
                                    >
                                      BAD NUMBER
                                    </span>
                                  )}
                                  {deal.lm_contact.unsubscribed_number && (
                                    <span
                                      style={{ marginRight: 4 }}
                                      className="label label-warning"
                                    >
                                      UNSUBSCRIBED NUMBER
                                    </span>
                                  )}
                                </Field>
                              )}

                              {deal.lm_contact.email && (
                                <Field
                                  label="LeadMachine Contact"
                                  value={
                                    deal.lm_contact.lm_contact_id ? (
                                      <a href={contactUrl} target="lm">
                                        open contact
                                      </a>
                                    ) : (
                                      <span>not created yet</span>
                                    )
                                  }
                                />
                              )}
                              {deal.lm_contact.mobile && (
                                <Field
                                  label="LeadMachine SMS"
                                  value={
                                    <a href={mcUrl} target="lm">
                                      search LeadMachine
                                    </a>
                                  }
                                />
                              )}
                            </div>
                            <div className="col-md-4">
                              <span style={{ fontSize: 13 }}>
                                {deal.lm_contact.quicknotes &&
                                  deal.lm_contact.quicknotes
                                    .split("\n")
                                    .map((item, key) => (
                                      <span key={key}>
                                        {item}
                                        <br />
                                      </span>
                                    ))}
                              </span>
                            </div>
                          </div>
                        </div>
                        {deal.related_contacts.map(contact => {
                          const contactUrl = deal.lm_contact
                            ? `${process.env.REACT_APP_LEADMACHINE_URL}/app#!/contacts/${deal.lm_contact.lm_contact_id}`
                            : "";
                          const internationalNumber = e164(
                            deal.lm_contact.mobile
                          );
                          const mcUrl = `${process.env.REACT_APP_LEADMACHINE_URL}/app#!/message_centre/messages/thread/${internationalNumber}`;

                          return (
                            <div
                              key={contact.id}
                              className="well"
                              style={{
                                border: "1px solid #ddd",
                                background: "rgba(251, 251, 251, 0.51)",
                                padding: 6
                              }}
                            >
                              <h4
                                style={{
                                  marginTop: 0,
                                  marginBottom: 4,
                                  paddingBottom: 4
                                }}
                              >
                                {contact.contact_type} - {contact.region} /{" "}
                                {examBoardForRegion(contact.region)}
                                <span className="pull-right">
                                  <Button
                                    style={{ marginRight: 6 }}
                                    bsStyle="info"
                                    bsSize="xsmall"
                                    onClick={() => {
                                      setShowModalEditContact(true);
                                      setEditContact(contact);
                                    }}
                                  >
                                    Edit
                                  </Button>
                                  <ConfirmButton
                                    hideNote
                                    text="Remove"
                                    message="This will remove the contact from this deal, but not delete it"
                                    bsStyle="info"
                                    bsSize="xsmall"
                                    okAction={() => removeContact(contact)}
                                  />
                                </span>
                              </h4>
                              <div className="row">
                                <div className="col-md-8">
                                  <Field
                                    label="Email"
                                    required={true}
                                    value={
                                      <Link to={`/m1/contacts/${contact.id}`}>
                                        {contact.email || "view contact"}
                                      </Link>
                                    }
                                  />
                                  <Field
                                    label="First Name"
                                    value={contact.first_name}
                                    required={true}
                                  />
                                  <Field
                                    label="Last Name"
                                    value={contact.last_name}
                                    required={true}
                                  />

                                  <Field
                                    label="Mobile"
                                    value={contact.mobile}
                                    dialer={true}
                                  />
                                  {(contact.bad_number ||
                                    contact.unsubscribed_number) && (
                                    <Field label="">
                                      {contact.bad_number && (
                                        <span
                                          style={{ marginRight: 4 }}
                                          className="label label-danger"
                                        >
                                          BAD NUMBER
                                        </span>
                                      )}
                                      {contact.unsubscribed_number && (
                                        <span
                                          style={{ marginRight: 4 }}
                                          className="label label-warning"
                                        >
                                          UNSUBSCRIBED NUMBER
                                        </span>
                                      )}
                                    </Field>
                                  )}

                                  {contact.email && (
                                    <Field
                                      label="LeadMachine Contact"
                                      value={
                                        contact.lm_contact_id ? (
                                          <a href={contactUrl} target="lm">
                                            open contact
                                          </a>
                                        ) : (
                                          <span>not created yet</span>
                                        )
                                      }
                                    />
                                  )}
                                  {contact.mobile && (
                                    <Field
                                      label="LeadMachine SMS"
                                      value={
                                        <a href={mcUrl} target="lm">
                                          search LeadMachine
                                        </a>
                                      }
                                    />
                                  )}
                                </div>
                                <div className="col-md-4">
                                  <span style={{ fontSize: 13 }}>
                                    {contact.quicknotes &&
                                      contact.quicknotes
                                        .split("\n")
                                        .map((item, key) => (
                                          <span key={key}>
                                            {item}
                                            <br />
                                          </span>
                                        ))}
                                  </span>
                                </div>
                              </div>
                            </div>
                          );
                        })}

                        <h5
                          style={{
                            marginBottom: 4,
                            paddingBottom: 4,
                            borderBottom: "1px solid #ccc"
                          }}
                        >
                          Additional Info
                        </h5>
                        <Field label="Booking from" value={deal.booking_from} />
                        <Field
                          label="Business stream"
                          value={deal.business_stream}
                        />
                        <Field
                          label="M1 Booking by"
                          value={deal.m1_booking_user}
                        />
                        <Field
                          label="Created At"
                          value={
                            <Moment format="MMM Do YYYY h:mm a">
                              {deal.created_at}
                            </Moment>
                          }
                        />

                        <h5
                          style={{
                            marginBottom: 4,
                            paddingBottom: 4,
                            borderBottom: "1px solid #ccc"
                          }}
                        >
                          UTM
                        </h5>
                        <Field label="UTM Source" value={deal.utm_source} />
                        <Field label="UTM Medium" value={deal.utm_medium} />
                        <Field label="UTM Campaign" value={deal.utm_campaign} />
                        <Field label="UTM Term" value={deal.utm_term} />
                        <Field label="UTM Content" value={deal.utm_content} />
                      </Tab>

                      <Tab
                        eventKey={2}
                        title="Sale"
                        disabled={!deal.flags.includes("sale_made")}
                      >
                        <Field label="Sale from" value={deal.sale_from} />
                        <Field label="Sale made by" value={deal.sale_made_by} />
                        <hr />
                        <Field
                          label="Value of Sale"
                          value={deal.value_of_sale}
                        />
                        <Field
                          label="Paid at Appt"
                          value={deal.amount_paid_at_appointment}
                        />
                        <Field
                          label="Plan Duration"
                          value={deal.plan_duration}
                        />
                        <Field
                          label="Plan Payments"
                          value={deal.plan_payments}
                        />

                        <hr />
                        {deal.date_sale_verified ? (
                          <React.Fragment>
                            <Field
                              label="Verified At"
                              value={moment(deal.date_sale_verified).format(
                                "DD MMM YYYY"
                              )}
                            />
                            <Field
                              label="Verified By"
                              value={deal.sale_verified_by}
                            />
                            <Field
                              label="Verification Notes"
                              value={deal.notes_verification_sale}
                              blockDisplay={true}
                            />
                          </React.Fragment>
                        ) : (
                          <p>Not yet verified</p>
                        )}
                      </Tab>

                      <Tab
                        eventKey={3}
                        title="Upgrade"
                        disabled={!deal.flags.includes("upgrade_made")}
                      >
                        <Field label="Upgrade from" value={deal.upgrade_from} />
                        <Field
                          label="Upgrade made by"
                          value={deal.upgrade_made_by}
                        />
                        <hr />

                        <Field
                          label="Value of Sale"
                          value={deal.value_of_sale_upgrade}
                        />
                        <Field
                          label="Paid at Appt"
                          value={deal.amount_paid_at_appointment_upgrade}
                        />
                        <Field
                          label="Plan Duration"
                          value={deal.plan_duration_upgrade}
                        />
                        <Field
                          label="Plan Payments"
                          value={deal.plan_payments_upgrade}
                        />

                        <hr />
                        {deal.date_upgrade_verified ? (
                          <React.Fragment>
                            <Field
                              label="Verified At"
                              value={moment(deal.date_upgrade_verified).format(
                                "DD MMM YYYY"
                              )}
                            />
                            <Field
                              label="Verified By"
                              value={deal.upgrade_verified_by}
                            />
                            <Field
                              label="Verification Notes"
                              value={deal.notes_verification_upgrade}
                              blockDisplay={true}
                            />
                          </React.Fragment>
                        ) : (
                          <p>Not yet verified</p>
                        )}
                      </Tab>

                      <Tab
                        eventKey={4}
                        title="Final Deal"
                        disabled={!deal.flags.includes("completed")}
                      >
                        {deal.flags.includes("no_sale") && (
                          <div>
                            <h5
                              style={{
                                marginBottom: 4,
                                paddingBottom: 4,
                                borderBottom: "1px solid #ccc"
                              }}
                            >
                              No Sale
                            </h5>
                            <Field
                              label="No Sale Reason"
                              value={deal.no_sale_reason}
                            />
                            <Field
                              label="No Sale Notes"
                              value={deal.notes_no_sale}
                              blockDisplay={true}
                            />
                            <hr />
                          </div>
                        )}

                        {deal.flags.includes("dead_deal") && (
                          <div>
                            <h5
                              style={{
                                marginBottom: 4,
                                paddingBottom: 4,
                                borderBottom: "1px solid #ccc"
                              }}
                            >
                              Dead Deal
                            </h5>
                            <Field
                              label="Dead Deal Reason"
                              value={deal.dead_deal_reason}
                            />
                            <Field
                              label="Dead Deal Notes"
                              value={deal.notes_dead_deal}
                              blockDisplay={true}
                            />
                            <hr />
                          </div>
                        )}

                        {deal.flags.includes("sale_made") && (
                          <div>
                            <Field
                              label="Value of Sale"
                              value={deal.value_of_sale}
                            />
                            <Field
                              label="Paid at Appt"
                              value={deal.amount_paid_at_appointment}
                            />
                            <Field
                              label="Plan Duration"
                              value={deal.plan_duration}
                            />
                            <Field
                              label="Plan Payments"
                              value={deal.plan_payments}
                            />
                            <hr />
                          </div>
                        )}

                        <Field label="Reviewed By" value={deal.reviewed_by} />
                        <Field
                          label="Review Outcome"
                          value={deal.review_outcome}
                        />
                        {deal.review_outcome === "declined" && (
                          <Field
                            label="Outcome Reason"
                            value={deal.outcome_reason}
                          />
                        )}
                        <Field
                          label="Review Notes"
                          value={deal.notes_review}
                          blockDisplay={true}
                        />
                      </Tab>

                      <Tab
                        eventKey={4.5}
                        title="Coaching Portal"
                        disabled={!deal.flags.includes("portal_setup")}
                      >
                        {deal.coaching && (
                          <Field label="Account">
                            <a
                              href={deal.coaching.account_url}
                              target="coaching"
                            >
                              go to Account
                            </a>
                          </Field>
                        )}
                        {deal.coaching && (
                          <Field label="Parent">
                            <a
                              href={deal.coaching.parent_url}
                              target="coaching"
                            >
                              go to Parent
                            </a>
                          </Field>
                        )}
                        {deal.coaching && (
                          <Field label="Student">
                            <a
                              href={deal.coaching.student_url}
                              target="coaching"
                            >
                              go to Student
                            </a>
                          </Field>
                        )}
                      </Tab>

                      <Tab
                        eventKey={5}
                        title="Notes"
                        disabled={
                          !deal.notes_admin &&
                          !deal.notes_coach &&
                          !deal.notes_review
                        }
                      >
                        <Field
                          label="Admin Notes"
                          value={deal.notes_admin}
                          blockDisplay={true}
                        />
                        <Field
                          label="Coach Notes"
                          value={deal.notes_coach}
                          blockDisplay={true}
                        />
                        <Field
                          label="Sale Verification Notes"
                          value={deal.notes_verification_sale}
                          blockDisplay={true}
                        />
                        <Field
                          label="Upgrade Verification Notes"
                          value={deal.notes_verification_upgrade}
                          blockDisplay={true}
                        />
                        <Field
                          label="Review Notes"
                          value={deal.notes_review}
                          blockDisplay={true}
                        />
                      </Tab>
                      <Tab eventKey={6} title="AI analysis">
                        {showAnalysisButton && (
                          <Button
                            style={{ marginBottom: 10, marginRight: 10 }}
                            bsStyle="info"
                            bsSize="xsmall"
                            onClick={() => {
                              handleAiAnalysisGeneration();
                            }}
                          >
                            {analysisButtonText}
                          </Button>
                        )}
                        {deal.ai_sales_report ? (
                          <>
                            <Field
                              label="Time Analysis"
                              value={
                                deal.ai_sales_report["analysis_reports"][0][
                                  "report"
                                ]
                              }
                              blockDisplay={true}
                            />
                            <Field
                              label="Objections"
                              value={
                                deal.ai_sales_report["analysis_reports"][1][
                                  "report"
                                ]
                              }
                              blockDisplay={true}
                            />
                            <Field
                              label="Script analysis"
                              value={
                                deal.ai_sales_report["analysis_reports"][2][
                                  "report"
                                ]
                              }
                              blockDisplay={true}
                            />
                          </>
                        ) : (
                          <p>
                            No reports are available at the moment. Press
                            'Generate Analysis' button to create one.
                          </p>
                        )}
                      </Tab>
                    </Tabs>
                  </Panel.Body>
                </Panel>
              </div>
              <div className="col-md-6">
                <SeminarRegistrationPanel
                  deal={deal}
                  openSeminars={openSeminars}
                />
                <TCSPanel deal={deal} assignTCS={assignTCS} />
                {!isRestrictedCoach && (
                  <CapacityAndCoachesPanel
                    tcsAt={deal.tcs_at}
                    capacityStats={capacityStats}
                  />
                )}
              </div>
            </div>

            <h4 style={{ marginTop: 10 }}>Extra Information</h4>

            <TaskPanel deal={deal} />

            <Panel bsStyle="success" className="compact-panel">
              <Panel.Heading>
                <Panel.Title componentClass="h3">History</Panel.Title>
              </Panel.Heading>
              <Panel.Body style={{ padding: 3 }}>
                {deal && deal.history ? (
                  <HistoryPanel history={deal.history} />
                ) : null}
              </Panel.Body>
            </Panel>
          </div>
        )}
      </Loadable>

      <EditContactModal
        showModal={showModalEditContact}
        contact={editContact}
        onConfirmModal={() => {
          setShowModalEditContact(false);
          setEditContact(undefined);
          contactUpdated();
        }}
        onCloseModal={() => {
          setShowModalEditContact(false);
          setEditContact(undefined);
        }}
      />

      <AddContactModal
        showModal={showModalAddContact}
        deal={deal}
        onConfirmModal={reloadDeal}
        onCloseModal={() => setShowModalAddContact(false)}
      />

      <AssignTCSModal
        showModal={showModalAssignTCS}
        deal={modalAssignDeal}
        onConfirmModal={() => {
          setShowModalAssignTCS(false);
          TCSAssigned();
        }}
        onCloseModal={() => setShowModalAssignTCS(false)}
      />
    </div>
  );
}));

export default Show;
